/**
 * The tag that ties a log of this flow to an account. `userId` is the only identifier this domain
 * may use: the email is PII and the link token must never be logged.
 */
export type SubjectAttributes = {
  userId?: string;
};

/**
 * Builds the subject tag of a log, and leaves the key out when there is no id: a key with
 * `undefined` reaches the collector as a tag that exists with no value.
 */
export const subjectAttributes = (userId?: string | null): SubjectAttributes => (userId ? { userId } : {});
